module.exports = __webpack_public_path__ + "img/coupon.aa0d6703.png";